import type { DisplayCue } from "@expert/contentful/src/types";

import { env } from "@/config";

export const getListeningText = (cues: DisplayCue[], isInsightsEnabled: boolean) => {
    const hasPreviousDetections = cues.some((c) => c.isDetectedOnPreviousCall);
    const hasCurrentDetections = cues.some((c) => c.detected && !c.isDetectedOnPreviousCall);

    const interactionType = env.channel === "chat" ? "chat" : "call";

    let listeningText = "Listening for devices";
    if (isInsightsEnabled) {
        listeningText = "Listening for tech and insights";
    } else if (hasPreviousDetections && hasCurrentDetections) {
        listeningText = `Detected from previous and current ${interactionType}`;
    } else if (hasCurrentDetections) {
        listeningText = `Detected from current ${interactionType}`;
    } else if (hasPreviousDetections) {
        listeningText = `Detected from previous ${interactionType}`;
    }

    return listeningText;
};
